import { Switch, SwitchProps } from "@headlessui/react";
import classNames from "classnames";

interface HDSwitchProps extends Omit<SwitchProps, "className" | "children"> {
    srLabel: string;
    className?: string;
}

/**
 * Standard switch component wrapping Headless UI Switch with HappyDoc styling
 * @param srLabel - Screen reader label text
 * @param className - Additional classes for the outer wrapper
 */
const HDSwitch = ({ checked, onChange, srLabel, className, disabled, ...rest }: HDSwitchProps) => {
    const trackClasses = classNames(
        checked ? "bg-max-900" : "bg-gray-200",
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
        "relative inline-flex items-center rounded-full border-transparent transition-colors duration-200 ease-in-out",
        "focused",
        "h-4 w-7 sm:h-5 sm:w-9",
    );

    const knobClasses = classNames(
        "h-2 w-2 sm:h-3 sm:w-3 transform transition ease-in-out duration-200 inline-block rounded-full bg-white",
        checked ? "translate-x-4 sm:translate-x-5" : "translate-x-1",
    );

    return (
        <Switch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={classNames(trackClasses, className)}
            {...rest}
        >
            <span className="sr-only">{srLabel}</span>
            <span aria-hidden="true" className={knobClasses} />
        </Switch>
    );
};

export default HDSwitch;
